export * from './24_smzsxxjdxx.component';